module.exports = __webpack_public_path__ + "static/media/icon-report-search.18de523d.svg";